import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(singleColumnLayout)/author/[...author]/Author.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Image/Image.js");
;
import(/* webpackMode: "eager" */ "/app/src/services/RouteService.js");
